/* vim: set expandtab sw=2 ts=2 sts=2: */
import thunk from 'redux-thunk';
import promise from 'redux-promise';
import logger from 'redux-logger';
//import crashReporter from './crashReporter';

const middleware = [thunk, promise];

if (process.env.NODE_ENV === 'development') {
  middleware.push(logger) 
//  middleware.push(crashReporter) 
}

export default middleware;



// WEBPACK FOOTER //
// ./usr/lib/ui/src/middleware/index.js